var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEspresso({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1C8078;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#936037;}\n\t.st3{fill:none;stroke:#432918;stroke-width:1.6563;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:#C6C6C6;stroke-width:1.8021;stroke-linecap:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.21,183.55c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C27.91,149.26,62.52,183.55,105.21,183.55"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.97,86.28l-2.67,0.95l-0.35,14.25l1.42,0.96c0,0,2.8,2.3,3.62-3.73c0.31-2.27,2.75-4.92,4.06-5.81 c3.17-2.17,8.88,0.47,8.92,6.11c0.03,3.06-0.49,6-1.65,8.6c-4.16,9.28-13.5,11.91-20.5,13.24c3.67-10.31,6.71-23.75,5.47-38.31 h-0.95c0.83-0.48,1.28-0.99,1.28-1.52c0-3.19-15.9-5.75-35.51-5.75c-19.61,0-35.49,2.57-35.49,5.75c0,0.53,0.45,1.04,1.27,1.52 h-1.18c0,0-3.1,33.7,15.96,59.67c0,0,18.79,9.58,39.46-1.1c0,0,1.92-2.83,4.37-7.74c1.24-0.57,3.32-1.7,6.84-3.94 c0,0,22.83-9.59,24.84-21.67C159.18,107.74,165.75,78.82,139.97,86.28z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "138.54,87.54 137.21,87.46 137.21,81.03 138.63,81.03  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "67.56,87.6 69.06,87.33 69.06,80.89 67.64,80.89  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M78.02,119.74c0,0,1.93,5.44,4.01,9.83c3.6,7.59,3.84,7.35,3.84,7.35s5.71,3.41,14.17,3.94 s19.11-3.19,19.11-3.19s3.01-4.25,6.21-11.05c1.55-3.3,3.67-8.21,3.67-8.21s-7.14-0.75-26.03-1.07S78.02,119.74,78.02,119.74z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M82.24,121.39c13.57,3.48,27.81,3.48,41.38,0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M74.63,86.69c18.89,2.99,38.14,2.99,57.03,0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEspresso);
export default __webpack_public_path__ + "static/media/Espresso.a491d2757811038868b2a75d08251bb3.svg";
export { ForwardRef as ReactComponent };